//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Card from '~/components/UserDashboard/dashboard/card'

export default {
  name: 'OurBenefits',
  components: { Card }
}
